export default __webpack_public_path__ + "static/media/1193.acc4ba8f.png";